import React, { useEffect, useState } from 'react';
import { Link, NavLink as RouterNavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/Navbar.css';

// Lien de menu avec mise en évidence de la page active
const NavLink = ({ to, children }) => (
  <RouterNavLink
    to={to}
    end={to === '/'}
    className={({ isActive }) => `navbar-item${isActive ? ' active' : ''}`}
  >
    {children}
  </RouterNavLink>
);

const Navbar = () => {
  const { user, logout, isAdmin, isSupervisorOrAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  // Refermer le menu mobile à chaque changement de page
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <nav className={`navbar${menuOpen ? ' menu-open' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/">
            <span className="brand-mark">A</span>
            <span className="brand-text">ARA & ESSIE-EHOUN</span>
          </Link>
        </div>

        {/* Bouton menu (téléphone uniquement) */}
        <button
          type="button"
          className="navbar-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>

        <div className="navbar-collapse">
          <div className="navbar-menu">
            <NavLink to="/">Accueil</NavLink>

            {/* Admin a accès à tout */}
            {isAdmin() && (
              <>
                <NavLink to="/admin/users">Utilisateurs</NavLink>
                <NavLink to="/admin/sms">SMS</NavLink>
                <NavLink to="/ara">Module ARA</NavLink>
                <NavLink to="/essie-ehoun">Module ESSIE-EHOUN</NavLink>
              </>
            )}

            {/* Superviseur a accès aux modules mais pas à l'admin */}
            {!isAdmin() && isSupervisorOrAdmin() && (
              <>
                <NavLink to="/ara">Module ARA</NavLink>
                <NavLink to="/essie-ehoun">Module ESSIE-EHOUN</NavLink>
              </>
            )}

            {/* Utilisateur normal n'a accès qu'à son module */}
            {!isSupervisorOrAdmin() && (
              <>
                {user.module === 'ARA' && (
                  <NavLink to="/ara">Module ARA</NavLink>
                )}

                {user.module === 'ESSIE-EHOUN' && (
                  <NavLink to="/essie-ehoun">Module ESSIE-EHOUN</NavLink>
                )}
              </>
            )}

            <NavLink to="/profile">Profil</NavLink>
          </div>

          <div className="navbar-user">
            <span className="user-info">
              {user.username}
              <small>{user.role}</small>
            </span>
            <button onClick={handleLogout} className="logout-btn">
              Déconnexion
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
